import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['trigger']

  connect() {
    this.element.addEventListener('on-page-filter:complete', this.handleFilter.bind(this))

    this.triggerTargets.forEach((trigger) => {
      trigger.addEventListener('click', this.activate.bind(this))
    })
  }

  activate(event) {
    this.triggerTargets.forEach((trigger) => trigger.classList.remove('active'))
    event.currentTarget.classList.add('active')
  }

  handleFilter() {
    const activeTrigger = this.triggerTargets.find(
      (trigger) => trigger.classList.contains('active')
    )

    if (!activeTrigger || !activeTrigger.checkVisibility()) {
      const enableTrigger = this.
        triggerTargets.
        find((trigger) => trigger.checkVisibility()) || this.triggerTargets[0]

      enableTrigger.click()
    }
  }
}
